import { Actions, thunk } from 'easy-peasy';
import api from '~/services/api';
import { IActTeamMemberActions, IThunkRestoreGlobalUser } from '../types';

const onRestoreGlobalUser: IThunkRestoreGlobalUser = thunk(
  async ({ restoreGlobalUser }: Actions<IActTeamMemberActions>, payload) => {
    const { clinicId, teamMemberId } = payload;

    await api.actTeamMember.restoreGlobalUser(clinicId, teamMemberId);

    restoreGlobalUser(teamMemberId);
  },
);

export default onRestoreGlobalUser;
